import { postRequest } from "./request";

export function BlockUser(dataObject) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return postRequest({
    path: `block-user`,
    token: userData.token,
    data: {
      m_id: dataObject,
    },
  }).then((response) => {
    return response ? response : undefined;
  });
}
